import { ModelInstance, BaseModel, ToBackHook, ToFrontHook } from './util';
import { HockeyStatistic } from './hockey-statistic';
import { GameTeamStatisticBase } from './game-team-statistic-base';

@ModelInstance({
  mappingFields: {
    team: 'team',
    competitor_team: 'competitorTeam'
  },
  relation: {
    team: HockeyStatistic,
    competitorTeam: HockeyStatistic
  }
})
export class HockeyGameTeamStatistic extends BaseModel implements GameTeamStatisticBase {
  team: HockeyStatistic;
  competitorTeam: HockeyStatistic;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
